import { mapGetters, mapMutations } from 'vuex';
import { required, minLength, between } from 'vuelidate/lib/validators';
import Multiselect from 'vue-multiselect'
import VueNumeric from 'vue-numeric'
import Datepicker from 'vuejs-datepicker';
import FileUpload from 'vue-upload-component'
import { attachmentService } from '../../services/AttachmentService';

import OrderPayments from './orderPayments.vue';

import store from '../../vuex/index'
export default {
    name: 'OfferComponent',

    components: {
        Datepicker,
        Multiselect,
        VueNumeric,
        FileUpload,
        OrderPayments
    },

    props:
    {

    },

    data: () => {
        return {
            loading: true,


            authHeaders: {},
            postUrl: '/api/Attachment/postFiles',
            //
            policyFiles: [],
            //
            policyUploadParams: {
                targetType: 0, // Policy
                targetId: 0
            },
            paymentUploadParams: {
                targetType: 1, // Payment
                targetId: 0
            },
            //
            policyUploaded: false,
            paymentUploaded: false,
            uploadCount: 0,
            uploadCountTarget: 0,
            //
            itemToBeDeleted: null,


            //
            orderSettings: {},
            insuranceCompany: null,
            insuranceCompanies: [],

            //
            offer: null,
            //
            period: null,
            periodOptions: [
                { Code: 1, Name: '1' },
                { Code: 2, Name: '2' },
                { Code: 3, Name: '3' },
                { Code: 4, Name: '4' },
                { Code: 5, Name: '5' },
                { Code: 6, Name: '6' },
                { Code: 7, Name: '7' },
                { Code: 8, Name: '8' },
                { Code: 9, Name: '9' },
                { Code: 10, Name: '10' },
                { Code: 11, Name: '11' },
                { Code: 12, Name: '12' },
            ],

        }
    },

    created() {

        this.getOffer();
        if (this.offer != null) {
            this.period = this.periodOptions.find(item => item.Code == this.offer.Period);
            this.insuranceCompany = { Code: this.offer.Insurer, Name: this.offer.Insurer };
        }
        this.orderSettings = this.typeSettings(this.order.OrderTypeId);
        this.insuranceCompanies = this.orderSettings.JsonSettings.AvailableInsurers;
        

        this.policyUploadParams = {
            targetId: this.order.Id,
            targetType: 0,
        };

        // Add the auth header manually here as the post will not be done through axios (so it's not added automatically)
        const authToken = store.getters['auth/authToken'];
        if (authToken) {
            this.authHeaders.Authorization = `Bearer ${authToken}`;
        }
    },
    validations: {
        offer: {
            Commission: {
                //required,
                between: between(0, 100000000)
            },
            CommissionPrc   : {
                //required,
                between: between(0, 100)
            },

            Period: {
                required
            },

        },
        order: {
            PolicyNo: {
                required
            },
        },
        insuranceCompany: {
            Code: {
                required
            },
        },
    },

    computed: {
        ...mapGetters(
            {
                // general
                orderTypeSettings: 'general/orderTypeSettings',
                typeSettings: 'general/typeSettings',
                currentOrderOffer: 'order/currentOrderOffer',
                order: 'order/order',
                orderEditable: 'order/orderEditable',
            }),

        fileName() {
            var fileNames = '';
            this.policyFiles.forEach(function (f) {
                fileNames += f.file.name;
            });
            return fileNames;
        },
        insuranceCompanyIsInvalid() {
            return this.$v.insuranceCompany.$anyError;
        },
     
        commissionIsInvalid() {
            return this.$v.offer.Commission.$anyError;
        },
        commissionPrcIsInvalid() {
            return this.$v.offer.CommissionPrc.$anyError;
        },
        periodIsInvalid() {
            return this.$v.offer.Period.$anyError;
        },

        isValid() {
            return !this.$v.$anyError;
        },
    },

    methods: {

        chkState: function (val) {
            const field = this.getDescendantProp(this.$v, val);

            return !field.$dirty || !field.$invalid
        },

        validate: function () {
            this.$v.$touch();
            this.$nextTick(() => this.findFirstError());

            return this.isValid;
        },
        //
        backButtonClick: function () {

        },

        insuranceCompany_changed: function (value) {
            this.insuranceCompany = value;
            this.offer.Insurer = value.Code;
        },

        getOffer: function () {
            this.offer = this.currentOrderOffer;
        },
        period_changed: function (value) {
            this.period = value;
            this.offer.Period = value.Code;
        },

        downloadPolicy: function (id) {
            var uploadParams = {
                targetType: 0,
                targetId: id
            };
            attachmentService.getAllAttachments(uploadParams).then((response) => {
                var attachments = response.data;
                if (attachments && attachments.length > 0) {
                    if (attachments[0].url)
                        window.location.href = attachments[0].url;
                    else
                        window.location.href = 'api/Attachment/Download/' + attachments[0].Id;
                }
                else {
                    this.showNoDocumentMessage('Download polita');
                }
            });
        },

        inputFile: function (newFile, oldFile) {
            if (newFile && newFile.isNew == undefined)
                newFile.isNew = true;

            if (newFile && oldFile && !newFile.active && oldFile.active) {
                // Get response data
                console.log('response', newFile.response)
                if (newFile.xhr) {
                    //  Get the response status code
                    console.log('status', newFile.xhr.status)
                }
            }
        },

        inputFilter: function (newFile, oldFile, prevent) {
            if (newFile && !oldFile) {
                // Filter non-image file
                if (!/\.(jpeg|jpg|gif|png|webp|pdf|zip|rar|doc|docx|xls|xlsx)$/i.test(newFile.name)) {
                    return prevent()
                }
            }

            if (newFile) {
                // Create a blob field
                newFile.blob = ''
                let URL = window.URL || window.webkitURL
                if (URL && URL.createObjectURL) {
                    newFile.blob = URL.createObjectURL(newFile.file)
                }
            }
        },

        showNoDocumentMessage: function (title) {
            this.boxTwo = ''
            this.$bvModal.msgBoxOk('Nu a fost gasit nici un document atasat.', {
                title: title,
                okVariant: 'success',
                buttonSize: 'lg',
                headerClass: 'p-2 border-bottom-1',
                footerClass: 'p-2 border-top-0 mx-auto',

                centered: true
            })
                .then(value => {
                    this.boxTwo = value
                })
                .catch(err => {
                    // An error occurred
                })
        },
    },
    watch: {
        'offer.CommissionPrc': {
            handler: function (val, oldVal) {
                if (this.offer.DirectSettlement) {
                    this.offer.Commission = this.offer.DirectSettlementPrice * val / 100;
                }
                else {
                    this.offer.Commission = this.offer.Price * val / 100;
                }
            },
        },
        'offer.Price': {
            handler: function (val, oldVal) {
                this.offer.Commission = this.offer.CommissionPrc * val / 100;
            },
        },
        'offer.DirectSettlementPrice': {
            handler: function (val, oldVal) {
                this.offer.Commission = this.offer.CommissionPrc * val / 100;
            },
        },
    }
}
